// sidebarStore.ts
import { create } from 'zustand';
import { HeaderStateTypes } from '../header/headerstate-types';

export const useHeaderStore = create<{
  headerState: HeaderStateTypes;
  setHeaderState: (state: Partial<HeaderStateTypes>) => void;
}>((set) => ({
  headerState: {
    showHeaderMenu: true,
  },
  setHeaderState: (state) =>
    set((prev) => ({
      headerState: { ...prev.headerState, ...state },
    })),
}));